module.exports = "/_next/static/media/logo-brands.41efa552.svg";